<!-- Modal (Cota de Promoção) -->

<ng-template #avisoCotaPromocao let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-aviso-cota"><b>Cota de Promoção</b></h3>
    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Alguns produtos excedem a cota da promoção. A quantidade disponível será enviada e o excedente irá para <b>pendência</b>:</p>
    <table class="table table-sm">
      <thead><tr><th>Produto</th><th class="text-right">Enviar</th><th class="text-right">Pendência</th></tr></thead>
      <tbody>
        @for (linha of cotaSplit; track linha.nome) {
          <tr><td>{{ linha.nome }}</td><td class="text-right">{{ linha.enviada }}</td><td class="text-right">{{ linha.pendencia }}</td></tr>
        }
      </tbody>
    </table>
  </div>
  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.dismiss('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Confirmar')">Confirmar</button>
  </div>
</ng-template>

<!-- Modal (Redução de preço por prazo) -->

<ng-template #confirmarReducaoPrecoPrazo let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-reducao-preco-prazo"><b>Alteração de Prazo</b></h3>
  </div>
  <div class="modal-body">
    <p>O novo prazo tem fator financeiro menor. Deseja <b>reduzir o preço</b> dos itens?</p>
    <p class="text-secondary mb-0">Se mantiver, o preço atual passa a ser a base caso o prazo seja alterado novamente.</p>
  </div>
  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Manter')">Não, manter preço</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Reduzir')">Sim, reduzir</button>
  </div>
</ng-template>

<!-- Modal (Bonificação) -->

<ng-template #comBonificacao let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-com-bonificacao"><b>Bonificação</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Bonificação gerada! Deseja alterar pedido gerado?</b></h5>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="d-flex justify-content-between">
      <div>
        <h6 class="text-secondary"><b>Número:</b></h6>
        <h6><b>{{ pedidoBonificacaoRetorno.numero_pedido_bonificado }}</b></h6>
      </div>

      <div class="text-right">
        <h6 class="text-secondary"><b>Bonificação: R$</b></h6>
        <h6><b>{{ pedidoBonificacaoRetorno.valor_pedido_bonificado | currency: 'BRL' }}</b></h6>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Não</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Sim</button>
  </div>
</ng-template>

<!-- Modal (Composição) -->

<ng-template #composicao let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-composicao"><b>Composição</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Origem:</b></label>

        <select class="form-control form-control-sm" name="origem_composicao" #origem_composicao (change)="selecionarOrigemComposicao(origem_composicao.value)">
          <option value="" selected></option>
          <option value="0">Produtos</option>
          <option value="1">Produtos (Adicionados)</option>
          <option value="2">Produtos (Adicionados (Original))</option>
          <option value="3">Produtos (Original)</option>
          <option value="4">Produtos (Selecionado)</option>
        </select>
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th colspan="7"></th>

            <th class="text-center tabela_borda" colspan="6">Inicial</th>

            <!-- Fator -->

            <!-- Inicial -->

            <th class="text-center tabela_borda" colspan="4">Fator (Inicial)</th>

            <!-- Processado -->

            <th class="text-center tabela_borda" colspan="5">Fator (Processado)</th>

            <!-- Imposto -->

            <th class="text-center tabela_borda" colspan="5">Imposto</th>

            <th class="text-center tabela_borda">Final</th>

            <th class="text-center tabela_borda"></th>
          </tr>

          <tr>
            <th></th>
            <th class="tabela_borda">Descrição</th>
            <th class="text-center tabela_borda">Q/A</th>
            <th class="text-center tabela_borda">Q/B</th>
            <th class="text-center tabela_borda">E/Q</th>
            <th class="text-center tabela_borda">E/V</th>
            <th class="text-center tabela_borda">Fator</th>

            <th class="text-right tabela_borda">Price: R$</th>
            <th class="text-right tabela_borda">Promocional: R$</th>

            <th class="text-right tabela_borda">Valor: R$</th>
            <th class="text-right tabela_borda">Total: R$</th>
            <th class="text-right tabela_borda">Vinculados: R$</th>
            <th class="text-right tabela_borda">Tabela: R$</th>

            <!-- Fator -->
            <!-- Inicial -->

            <th class="text-right tabela_borda">Porcentagem: %</th>
            <th class="text-right tabela_borda">Inicial: R$</th>
            <th class="text-right tabela_borda">Tabela: R$</th>
            <th class="text-right tabela_borda">Fracionado: R$</th>

            <!-- Processado -->

            <th class="text-right tabela_borda">Porcentagem: %</th>
            <th class="text-right tabela_borda">Fator: R$</th>
            <th class="text-right tabela_borda">Unitário: R$</th>
            <th class="text-right tabela_borda">Produto: R$</th>
            <th class="text-right tabela_borda">Total: R$</th>

            <!-- Imposto -->

            <th class="text-right tabela_borda">Imposto: R$</th>
            <th class="text-right tabela_borda">Unitário: R$</th>
            <th class="text-right tabela_borda">Produto: R$</th>
            <th class="text-right tabela_borda">Total: R$</th>

            <th class="text-right tabela_borda">Final: R$</th>

            <th class="text-right tabela_borda">Unitário: R$</th>

            <th class="text-right tabela_borda">D/T: %</th>
          </tr>
        </thead>

        <tbody>
          @for (produtoComposicao of produtosComposicoes; track produtoComposicao) {
            <tr>
              <td class="text-center tabela_acao">
                @if (produtoComposicao.id_campanha != null && produtoComposicao.id_campanha != 0) {
                  <i class="fa  btn_tabela_acao" [ngClass]="produtoComposicao.expandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirProdutoCampanhaComposicao(produtoComposicao.id_campanha)"></i>
                }
              </td>
              <td class="tabela_borda">{{ produtoComposicao.name }}</td>
              <td class="text-center tabela_borda">{{ produtoComposicao.qtde }}</td>
              <td class="text-center tabela_borda">{{ produtoComposicao.qtde_bonificada }}</td>
              <td class="text-center tabela_borda">{{ produtoComposicao.erro_qtde ? 'S' : 'N' }}</td>
              <td class="text-center tabela_borda">{{ produtoComposicao.erro_valor ? 'S' : 'N' }}</td>
              <td class="text-center tabela_borda">{{ produtoComposicao.aplica_fator_financeiro ? 'S' : 'N' }}</td>
              <td class="text-right tabela_borda">{{ produtoComposicao.price | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda">{{ produtoComposicao.price_promotional | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela">{{ formatarValoresQuatroCasasDecimais(produtoComposicao.valor) }}</td>
              <td class="text-right tabela_borda">{{ produtoComposicao.valor_total | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda">{{ produtoComposicao.valor_total_produtos_vinculados | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda">{{ produtoComposicao.valor_tabela | currency: 'BRL' }}</td>
              <!-- Fator -->
              <!-- Inicial -->
              <td class="text-right tabela_borda bg_tabela">{{ produtoComposicao.porcentagem_fator_inicial | currency: 'BRL' : '' }}</td>
              <td class="text-right tabela_borda bg_tabela">{{ produtoComposicao.valor_fator_financeiro_inicial | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela">{{ produtoComposicao.valor_fator_financeiro_tabela | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela">{{ produtoComposicao.valor_fator_financeiro_tabela_fracionado | currency: 'BRL' }}</td>
              <!-- Processado -->
              <td class="text-right tabela_borda bg_tabela_info">{{ produtoComposicao.porcentagem_fator | currency: 'BRL' : '' }}</td>
              <td class="text-right tabela_borda bg_tabela_info">{{ valorFatorTotalItem(produtoComposicao) | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela_info"><b>{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produtoComposicao)) }}</b></td>
              <td class="text-right tabela_borda bg_tabela_info"><b>{{ produtoComposicao.valor_fator_financeiro_produto | currency: 'BRL' }}</b></td>
              <td class="text-right tabela_borda bg_tabela_info">{{ produtoComposicao.valor_fator_financeiro_total | currency: 'BRL' }}</td>
              <!-- Imposto -->
              <td class="text-right tabela_borda bg_tabela_warning">{{ produtoComposicao.valor_imposto | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela_warning"><b>{{ formatarValoresQuatroCasasDecimais(produtoComposicao.valor_imposto_unitario) }}</b></td>
              <td class="text-right tabela_borda bg_tabela_warning">{{ produtoComposicao.valor_imposto_produto | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela_warning">{{ produtoComposicao.valor_imposto_total | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela_warning">{{ produtoComposicao.valor_imposto_total_final | currency: 'BRL' }}</td>
              <td class="text-right tabela_borda bg_tabela_danger">{{ formatarValoresQuatroCasasDecimais(produtoComposicao.valor_unitario_final) }}</td>
              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(produtoComposicao.porcentagem_desconto_temporaria, true) }}</td>
            </tr>
            <tr>
              @if (produtoComposicao.expandido) {
                <td class="p-4" colspan="29">
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th colspan="4"></th>
                          <th class="text-center tabela_borda" colspan="6">Inicial</th>
                          <!-- Fator -->
                          <!-- Inicial -->
                          <th class="text-center tabela_borda" colspan="4">Fator (Inicial)</th>
                          <!-- Processado -->
                          <th class="text-center tabela_borda" colspan="5">Fator (Processado)</th>
                          <!-- Imposto -->
                          <th class="text-center tabela_borda" colspan="5">Imposto</th>
                          <th class="text-center tabela_borda">Final</th>
                        </tr>
                        <tr>
                          <th>Descrição</th>
                          <th class="text-center tabela_borda">Q/A</th>
                          <th class="text-center tabela_borda">Q/M</th>
                          <th class="text-center tabela_borda">Fator</th>
                          <th class="text-right tabela_borda">Price: R$</th>
                          <th class="text-right tabela_borda">Promocional: R$</th>
                          <th class="text-right tabela_borda">Valor: R$</th>
                          <th class="text-right tabela_borda">Total: R$</th>
                          <th class="text-right tabela_borda">Vinculados: R$</th>
                          <th class="text-right tabela_borda">Tabela: R$</th>
                          <!-- Fator -->
                          <!-- Inicial -->
                          <th class="text-right tabela_borda">Porcentagem: %</th>
                          <th class="text-right tabela_borda">Inicial: R$</th>
                          <th class="text-right tabela_borda">Tabela: R$</th>
                          <th class="text-right tabela_borda">Fracionado: R$</th>
                          <!-- Processado -->
                          <th class="text-right tabela_borda">Porcentagem: %</th>
                          <th class="text-right tabela_borda">Fator: R$</th>
                          <th class="text-right tabela_borda">Unitário: R$</th>
                          <th class="text-right tabela_borda">Produto: R$</th>
                          <th class="text-right tabela_borda">Total: R$</th>
                          <!-- Imposto -->
                          <th class="text-right tabela_borda">Imposto: R$</th>
                          <th class="text-right tabela_borda">Unitário: R$</th>
                          <th class="text-right tabela_borda">Produto: R$</th>
                          <th class="text-right tabela_borda">Total: R$</th>
                          <th class="text-right tabela_borda">Final: R$</th>
                          <th class="text-right tabela_borda">Unitário: R$</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (produtoVinculado of produtoComposicao.produtos_vinculados; track produtoVinculado) {
                          <tr>
                            <td>
                              <div class="d-flex">
                                <div>{{ produtoVinculado.name }}</div>
                                @if (produtoVinculado.bonificacao) {
                                  <span class="badge badge-success ml-2">Bonificação</span>
                                }
                              </div>
                            </td>
                            <td class="text-center tabela_borda">{{ produtoVinculado.qtde }}</td>
                            <td class="text-center tabela_borda">{{ produtoVinculado.qtde_minima }}</td>
                            <td class="text-center tabela_borda">{{ produtoVinculado.aplica_fator_financeiro ? 'S' : 'N' }}</td>
                            <td class="text-right tabela_borda">{{ produtoVinculado.price | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda">{{ produtoVinculado.price_promotional | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela">{{ produtoVinculado.valor | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda">{{ produtoVinculado.valor_total | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda">{{ produtoVinculado.valor_total_produtos_vinculados | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda">{{ produtoVinculado.valor_tabela | currency: 'BRL' }}</td>
                            <!-- Fator -->
                            <!-- Inicial -->
                            <td class="text-right tabela_borda bg_tabela">{{ produtoVinculado.porcentagem_fator_inicial | currency: 'BRL' : '' }}</td>
                            <td class="text-right tabela_borda bg_tabela">{{ produtoVinculado.valor_fator_financeiro_inicial | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela">{{ produtoVinculado.valor_fator_financeiro_tabela | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela">{{ produtoVinculado.valor_fator_financeiro_tabela_fracionado | currency: 'BRL' }}</td>
                            <!-- Processado -->
                            <td class="text-right tabela_borda bg_tabela_info">{{ produtoVinculado.porcentagem_fator | currency: 'BRL' : '' }}</td>
                            <td class="text-right tabela_borda bg_tabela_info">{{ valorFatorTotalItem(produtoVinculado) | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela_info"><b>{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produtoVinculado)) }}</b></td>
                            <td class="text-right tabela_borda bg_tabela_info"><b>{{ produtoVinculado.valor_fator_financeiro_produto | currency: 'BRL' }}</b></td>
                            <td class="text-right tabela_borda bg_tabela_info">{{ produtoVinculado.valor_fator_financeiro_total | currency: 'BRL' }}</td>
                            <!-- Imposto -->
                            <td class="text-right tabela_borda bg_tabela_warning">{{ produtoVinculado.valor_imposto | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela_warning"><b>{{ formatarValoresQuatroCasasDecimais(produtoVinculado.valor_imposto_unitario) }}</b></td>
                            <td class="text-right tabela_borda bg_tabela_warning">{{ produtoVinculado.valor_imposto_produto | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela_warning">{{ produtoVinculado.valor_imposto_total | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela_warning">{{ produtoVinculado.valor_imposto_total_final | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda bg_tabela_danger">{{ formatarValoresQuatroCasasDecimais(produtoVinculado.valor_unitario_final) }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <hr class="mt-2 mb-2" />

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Desconto) -->

<ng-template #descontoItens let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-desconto-itens"><b>Desconto Itens</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group offset-3 col-sm-3">
        <label><b>Desconto Máximo: %</b></label>

        <input class="form-control form-control-sm" type="text" name="desconto" [value]="prazoMedioDesconto == null ? '' : prazoMedioDesconto.percentual_desconto" disabled />
      </div>

      <div class="form-group col-sm-3">
        <label><b>Desconto Aplicado: %</b></label>

        <input class="form-control form-control-sm" type="number" min="0" max="100" step="1" name="descontoAplicado" (focusout)="validarDescontoAplicado()" (input)="validarDescontoAplicado()" [ngClass]="{ 'is-invalid': porcentagemDescontoAplicadoErro }" [(ngModel)]="porcentagemDescontoAplicado" />

        @if (porcentagemDescontoAplicadoErro) {
          <div class="erro pt-1">Desconto Aplicado inválido!</div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('SalvarEnviar')">Salvar / Enviar</button>
  </div>
</ng-template>

<!-- Modal (Notas Fiscais (Sintéticas)) -->

<ng-template #notasFiscaisSinteticas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-notas-fiscais-sinteticas"><b>Notas fiscais e duplicatas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-modal-notas-fiscais [notasFiscais]="notasFiscais"></app-pedido-modal-notas-fiscais>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Locais de Entrega) -->

<ng-template #locaisEntregaModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-locais-entrega"><b>Locais de Entrega do Cliente</b></h3>
    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-pedido-modal-locais-entrega
      [clienteLocaisEntrega]="clienteLocaisEntrega"
      [loadingLocalEntrega]="loadingLocalEntrega"
      [erroLocalEntrega]="erroLocalEntrega">
    </app-pedido-modal-locais-entrega>
  </div>
  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Reprovar) -->

<ng-template #pedidoReprovar let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pedido-reprovar"><b>Reprovar (Pedido)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Motivo:</b></label>

          <input class="form-control form-control-sm" type="text" name="motivo" [(ngModel)]="motivoReprovacao" />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<ng-template #resumoFinanceiroModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>Resumo Financeiro</b></h3>
    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    @if (resumoFinanceiroCarregando) {
      <div class="text-center py-2">
        <span class="text-secondary"><b>Carregando Resumo Financeiro...</b></span>
      </div>
    }

    @if (resumoFinanceiroErro && !resumoFinanceiroCarregando) {
      <div class="text-center py-2">
        <span class="text-danger"><b>Não foi possível carregar o Resumo Financeiro.</b></span>
      </div>
    }

    @if (resumoFinanceiro != null && !resumoFinanceiroCarregando) {
      <div class="mb-1">
        <small class="text-secondary"><b>COD ERP:</b> {{ resumoFinanceiro.codErp }} &nbsp;&nbsp; <b>CLIENTE:</b> {{ resumoFinanceiro.clienteNome }}</small>
        @if (resumoFinanceiro.baixasNominais) {
          <p class="small text-secondary mt-2 mb-1">Valores baixados são nominais e podem incluir compensações, descontos ou outras baixas; não representam necessariamente dinheiro recebido. A data exibida é a última baixa do título.</p>
          @if (resumoFinanceiro.totalBaixadoSemClassificacao > 0) {
            <p class="small text-warning mb-1">Baixas parciais ou sem data, não classificadas nos totais de atraso: {{ resumoFinanceiro.totalBaixadoSemClassificacao | currency: 'BRL' }}.</p>
          }
        }
      </div>
      <div class="d-flex flex-wrap mb-2">
        <div class="confirmacao_item mr-1 mb-1 p-1">
          <h6 class="text-secondary mb-0"><b>TOTAL ABERTO ATRASADO</b></h6>
          <h6 class="text-danger mb-0"><b>{{ resumoFinanceiro.totalAbertoAtrasado | currency: 'BRL' }}</b></h6>
        </div>
        <div class="confirmacao_item mr-1 mb-1 p-1">
          <h6 class="text-secondary mb-0"><b>TOTAL ABERTO EM DIA</b></h6>
          <h6 class="text-success mb-0"><b>{{ resumoFinanceiro.totalAbertoEmDia | currency: 'BRL' }}</b></h6>
        </div>
        <div class="confirmacao_item mr-1 mb-1 p-1">
          <h6 class="text-secondary mb-0"><b>{{ resumoFinanceiro.baixasNominais ? 'TOTAL BAIXADO ATRASADO' : 'TOTAL PAGO ATRASADO' }}</b></h6>
          <h6 class="text-warning mb-0"><b>{{ resumoFinanceiro.totalPagoAtrasado | currency: 'BRL' }}</b></h6>
        </div>
        <div class="confirmacao_item mr-1 mb-1 p-1">
          <h6 class="text-secondary mb-0"><b>{{ resumoFinanceiro.baixasNominais ? 'TOTAL BAIXADO EM DIA' : 'TOTAL PAGO EM DIA' }}</b></h6>
          <h6 class="mb-0"><b>{{ resumoFinanceiro.totalPagoEmDia | currency: 'BRL' }}</b></h6>
        </div>
      </div>
      <div class="table-responsive bg-white">
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-center">EMISSÃO</th>
              <th class="text-center tabela_borda" style="cursor:pointer;" (click)="alternarOrdemResumoFinanceiroVencimento()">
                VENCIMENTO
                <span [style.opacity]="resumoFinanceiroOrdemAtiva === 'vencimento' ? '1' : '0.3'">
                  @if (resumoFinanceiroOrdemVencimentoDesc) {
                    <span>&#9660;</span>
                  }
                  @if (!resumoFinanceiroOrdemVencimentoDesc) {
                    <span>&#9650;</span>
                  }
                </span>
              </th>
              <th class="tabela_borda">NÚMERO NF</th>
              <th class="tabela_borda">PARCELA</th>
              <th class="text-right tabela_borda" style="cursor:pointer;" (click)="alternarOrdemResumoFinanceiro()">
                VALOR PARCELA
                <span [style.opacity]="resumoFinanceiroOrdemAtiva === 'valor' ? '1' : '0.3'">
                  @if (resumoFinanceiroOrdemDesc) {
                    <span>&#9660;</span>
                  }
                  @if (!resumoFinanceiroOrdemDesc) {
                    <span>&#9650;</span>
                  }
                </span>
              </th>
              <th class="text-center tabela_borda">{{ resumoFinanceiro.baixasNominais ? 'ÚLTIMA BAIXA' : 'DATA PAGAMENTO' }}</th>
              <th class="text-right tabela_borda">{{ resumoFinanceiro.baixasNominais ? 'VALOR BAIXADO' : 'VALOR PAGO' }}</th>
              @if (resumoFinanceiro.baixasNominais) { <th class="text-right tabela_borda">SALDO ABERTO</th> }
<th class="text-center tabela_borda">DIAS</th>
              <th class="text-center tabela_borda">STATUS</th>
            </tr>
          </thead>
          <tbody>
            @for (titulo of resumoFinanceiroItens; track titulo) {
              <tr>
                <td class="text-center">{{ titulo.docDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center tabela_borda">{{ titulo.dueDate | date: 'dd/MM/yyyy' }}</td>
                <td class="tabela_borda">{{ titulo.serial }}</td>
                <td class="tabela_borda">{{ titulo.parcela }}</td>
                <td class="text-right tabela_borda">{{ titulo.instTotal | currency: 'BRL' }}</td>
                <td class="text-center tabela_borda">{{ titulo.dataPagamento | date: 'dd/MM/yyyy' }}</td>
                <td class="text-right tabela_borda">{{ titulo.paidToDate | currency: 'BRL' }}</td>
                @if (resumoFinanceiro.baixasNominais) { <td class="text-right tabela_borda">{{ titulo.saldoAberto | currency: 'BRL' }}</td> }
                <td class="text-center tabela_borda">
                  @if (titulo.status?.trim()?.toUpperCase() === 'C' && titulo.dias != null) {
                    <span [ngClass]="titulo.dias < 0 ? 'text-danger' : titulo.dias === 0 ? 'text-success' : 'text-primary'">
                      <b>{{ titulo.dias }}</b>
                    </span>
                  }
                </td>
                <td class="text-center tabela_borda">
                  @if (titulo.status?.trim()?.toUpperCase() === 'P') {
                    <span class="badge badge-info">PARCIAL</span>
                  }
                  @if (titulo.status?.trim()?.toUpperCase() === 'O') {
                    <span class="badge badge-warning">ABERTO</span>
                  }
                  @if (titulo.status?.trim()?.toUpperCase() === 'C') {
                    <span class="badge badge-success">{{ resumoFinanceiro.baixasNominais ? 'BAIXADO' : 'PAGO' }}</span>
                  }
                  @if (titulo.status?.trim()?.toUpperCase() !== 'O' && titulo.status?.trim()?.toUpperCase() !== 'C' && titulo.status?.trim()?.toUpperCase() !== 'P') {
                    <span class="badge badge-secondary">{{ titulo.status }}</span>
                  }
                </td>
              </tr>
            }
            @if (resumoFinanceiroItens.length === 0) {
              <tr>
                <td [attr.colspan]="resumoFinanceiro.baixasNominais ? 10 : 9" class="text-center text-secondary">Nenhum título encontrado.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.dismiss()">Fechar</button>
  </div>
</ng-template>

<div class="container-fluid p-0">
  <!-- Título -->

  @if (!carregando) {
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4" [@esvanecerDesvanecer]="'in'">
      @if (pedido == null) {
        <div class="titulo_texto">Novo Pedido / Orçamento</div>
      }
      @if (pedido != null && !pedidoAprovarExterno) {
        <div class="titulo_texto">Alterar Pedido / Orçamento ({{ pedido.order_id_app }})</div>
      }
      @if (pedido != null && pedidoAprovarExterno) {
        <div class="titulo_texto">Aprovar Pedido ({{ pedido.order_id_app }})</div>
      }
    </div>
  }

  @if (!carregando) {
    <div [@esvanecerDesvanecer]="'in'">
      <!-- Itens (Menu) -->
      <div class="pt-3 pr-4 pb-0 pl-4">
        <div class="d-flex flex-wrap justify-content-center itens_menu">
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 0 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(0)">
            1. Cabeçalho
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 1 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(1)">
            2. Itens
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 2 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(2)">
            3. Detalhes
          </div>
          <div class="item_menu pt-2 pb-2 pl-3 mr-0" [ngClass]="itemSelecionado == 3 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(3)">
            4. Confirmação
          </div>
        </div>
        <hr class="mt-2 mb-2" />
      </div>
      <!-- Cabeçalho -->
      @if (itemSelecionado == 0) {
        <div class="pr-4 pb-4 pl-4 pedido-secao-restilizada" [@desvanecer]="'in'">
          <!-- Cliente (Filtrar) -->
          <app-pedido-cliente-busca
            [pedido]="pedido"
            [produtosAdicionados]="produtosAdicionados"
            [clienteSelecionadoExterno]="clienteSelecionadoExterno"
            [duplicandoPedido]="duplicandoPedido"
            [formFiltroCliente]="formFiltroCliente"
            [filtroClientes]="filtroClientes"
            [enviadoCliente]="enviadoCliente"
            [filtrandoCliente]="filtrandoCliente"
            [clientes]="clientes"
            [clienteSelecionado]="clienteSelecionado"
            [modalLocaisEntrega]="locaisEntregaModal"
            [itemSize]="10"
            (filtroSubmetido)="filtrarCliente()"
            (filtroAlterado)="alterarFiltroCliente($event)"
            (clienteEscolhido)="selecionarClienteFiltrado($event.codigo, $event.existente)"
            (abrirLocaisEntrega)="modalLocaisEntrega($event)">
          </app-pedido-cliente-busca>
          <!-- Cliente (Selecionado) -->
          <app-pedido-cliente-selecionado
            [clienteSelecionado]="clienteSelecionado"
            [clienteInvalido]="clienteInvalido"
            [modalNotasFiscais]="notasFiscaisSinteticas"
            (abrirNotasFiscais)="modalNotasFiscaisSinteticas($event, clienteSelecionado.client_document)">
          </app-pedido-cliente-selecionado>
          <!-- Cabeçalho (campos) -->
          <app-pedido-cabecalho-campos
            [pedidoAprovarExterno]="pedidoAprovarExterno"
            [clienteSelecionado]="clienteSelecionado"
            [configuracao]="configuracao"
            [produtosAdicionados]="produtosAdicionados"
            [pedidoOrcamentoSelecionado]="pedidoOrcamentoSelecionado"
            [canalVendasSelecionado]="canalVendasSelecionado"
            [vendedores]="vendedores"
            [vendedorSelecionado]="vendedorSelecionado"
            [pedido]="pedido"
            [is_master]="is_master"
            [is_manager]="is_manager"
            [is_diretor]="is_diretor"
            [bloquearAlteracaoVendedor]="bloquearAlteracaoVendedor"
            [tiposPedido]="tiposPedido"
            [tiposPedidoSelecionado]="tiposPedidoSelecionado"
            [transportadoras]="transportadoras"
            [transportadoraSelecionada]="transportadoraSelecionada"
            [tiposFrete]="tiposFrete"
            [tipoFreteSelecionado]="tipoFreteSelecionado"
            [produtosReferenciasCliente]="produtosReferenciasCliente"
            [produtoReferenciaClienteSelecionado]="produtoReferenciaClienteSelecionado"
            [formasPagamento]="formasPagamento"
            [formaPagamentoSelecionada]="formaPagamentoSelecionada"
            [dataValidade]="dataValidade"
            [dataValidadeInvalida]="dataValidadeInvalida"
            [dataPrevisaoEntrega]="dataPrevisaoEntrega"
            [clienteLocaisEntrega]="clienteLocaisEntrega"
            [clienteLocalEntregaSelecionado]="clienteLocalEntregaSelecionado"
            (pedidoOrcamentoAlterado)="selecionarPedidoOrcamento($event)"
            (canalVendaAlterado)="selecionarCanalVenda($event)"
            (vendedorAlterado)="selecionarVendedor($event)"
            (tipoPedidoAlterado)="selecionarTipoPedido($event)"
            (transportadoraAlterada)="selecionarTransportadora($event)"
            (freteAlterado)="selecionarFrete($event)"
            (referenciaClienteAlterada)="alterarProdutoReferenciaCliente($event)"
            (formaPagamentoAlterada)="selecionarFormaPagamento($event)"
            (localEntregaAlterado)="selecionarLocalEntrega($event)"
            (dataValidadeAlterada)="dataValidade = $event"
            (dataPrevisaoEntregaAlterada)="dataPrevisaoEntrega = $event">
          </app-pedido-cabecalho-campos>
          <!-- Prazo de Pagamento -->
          @if (configuracao != null && configuracao.prazo_pagamento_antes_itenspedido) {
            <hr class="mt-2 mb-2" />
            <div class="form-row">
              <div class="form-group col-sm-8">
                <label><b>Prazo de Pagamento:</b></label>
                <app-prazo-pagamento-select
                  [prazosIniciais]="prazosPagamentoIniciais"
                  [prazosEspeciais]="prazosPagamentoEspeciais"
                  [prazoSelecionado]="prazoPagamentoSelecionado"
                  [desabilitado]="clienteSelecionado == null || revalidandoPrazo || (!configuracao?.prazo_pagamento_antes_itenspedido && produtosAdicionados.length > 0)"
                  [invalido]="prazoPagamentoInvalido"
                  [ocultarTitulosIniciais]="configuracao != null && configuracao.flag_usa_prazo_vinculado_cliente"
                  (prazoChange)="alterarPrazoPagamento($event.toString(), true)">
                </app-prazo-pagamento-select>
                @if (prazoPagamentoInvalido) {
                  <div class="erro pt-1">Prazo de Pagamento inválido!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Prazo Médio:</b></label>
                <input class="form-control form-control-sm" type="text" name="prazo_medio" [value]="prazoMedio == null || prazoMedio.prazomedio == 0 ? '' : prazoMedio.prazomedio" disabled />
              </div>
              @if (configuracao != null && configuracao.usar_desconto_prazo_medio == 'S') {
                <div class="form-group col-sm-2">
                  <label><b>Desconto Máximo: %</b></label>
                  <input class="form-control form-control-sm" type="text" name="desconto" [value]="prazoMedioDesconto == null ? '' : prazoMedioDesconto.percentual_desconto" disabled />
                </div>
              }
            </div>
          }
          <hr class="mt-2 mb-2" />
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(0)">Prosseguir</button>
            @if (pedidoAprovarExterno) {
              <button class="btn btn-danger btn_formulario" type="button" (click)="reprovar(pedidoReprovar)">Reprovar</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirResumoFinanceiro(resumoFinanceiroModal)">Analisar</button>
            }
            @if ((is_master || is_diretor) && clienteSelecionado != null) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirAnaliseFinanceiraCliente(resumoFinanceiroModal)">Análise Financeira</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-success btn_formulario" type="button" (click)="aprovar()">Aprovar</button>
            }
          </div>
        </div>
      }
      <!-- Itens (Produtos) -->
      @if (itemSelecionado == 1) {
        <div class="pedido-itens-layout" [@desvanecer]="'in'">
          <div class="pedido-itens-principal">
            <app-pedido-itens-passo1-toolbar
            [pedidoAprovarExterno]="pedidoAprovarExterno"
            [calculando]="calculando || revalidandoPrazo"
            [prazosPagamentoIniciais]="prazosPagamentoIniciais"
            [prazosPagamentoEspeciais]="prazosPagamentoEspeciais"
            (prazoAlterado)="alterarPrazoPagamento($event, false)"
            [configuracao]="configuracao"
            [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
            [clienteSelecionado]="clienteSelecionado"
            [prazoPagamentoInvalido]="prazoPagamentoInvalido"
            [prazoMedio]="prazoMedio"
            [prazoMedioDesconto]="prazoMedioDesconto"
            [contaCorrenteSaldoDisponivel]="contaCorrenteSaldoDisponivel"
            [saldoGeradoValorFinal]="saldoGeradoValorFinal">
          </app-pedido-itens-passo1-toolbar>
            <section class="pedido-itens-card" aria-label="Itens do pedido">
              <header class="pedido-itens-header">
                <div><h2><i class="fa fa-cube" aria-hidden="true"></i> Itens do pedido</h2><p>{{ produtosAdicionados.length }} {{ produtosAdicionados.length === 1 ? 'item adicionado' : 'itens adicionados' }}</p></div>
                @if (!pedidoAprovarExterno) { <button class="btn btn-primary" type="button" (click)="modalAdicionarItens(0, 0)" [disabled]="calculando"><i class="fa fa-plus" aria-hidden="true"></i> Adicionar item</button> }
              </header>
              <app-pedido-itens-tabela
            [pedidoAprovarExterno]="pedidoAprovarExterno"
            [calculando]="calculando || revalidandoPrazo"
            (itemEditado)="modalAdicionarItens($event.id_produto, $event.id_campanha)"
            (itemExcluido)="excluirItemAdicionado($event.indice, $event.id_produto, $event.id_campanha)"
            [configuracao]="configuracao"
            [produtosAdicionados]="produtosAdicionados"
            [pedidoItensInativos]="pedidoItensInativos"
            [fatorFinanceiroAtivo]="fatorFinanceiroAtivo()"
            [podeExibirMargemItemPedido]="podeExibirMargemItemPedido()"
            [exibirPontuacao]="exibirPontuacao"
            [exibirFatorFinanceiro]="exibirFatorFinanceiro"
            [calcularMargemItemPedido]="calcularMargemItemPedido.bind(this)"
            [valorSemFatorItem]="valorSemFatorItem.bind(this)"
            [valorFatorItem]="valorFatorItem.bind(this)"
            [formatarValoresQuatroCasasDecimais]="formatarValoresQuatroCasasDecimais.bind(this)">
          </app-pedido-itens-tabela>
            </section>
                      @if (usaPendencia && temItensPendencia()) {
            <app-pedido-itens-pendencia [produtosAdicionados]="produtosAdicionados"></app-pedido-itens-pendencia>
          }
          @if (usaPendencia && pedidosPendencia && pedidosPendencia.length > 0) {
            <app-pedidos-pendencia-vinculados [pedidosPendencia]="pedidosPendencia"></app-pedidos-pendencia-vinculados>
          }

          </div>
          <aside class="pedido-itens-sidebar" aria-label="Resumo e resultado">
            <button class="btn btn-primary pedido-prosseguir-topo" type="button" (click)="prosseguirItemSelecionado(1)" [disabled]="calculando">Prosseguir para detalhes →</button>
            <app-pedido-itens-resumo
            [produtosAdicionadosLength]="produtosAdicionados.length"
            [valorTotalPesoProdutosAdicionados]="valorTotalPesoProdutosAdicionados"
            [valorParcialProdutosAdicionados]="valorParcialProdutosAdicionados"
            [exibirFatorFinanceiro]="exibirFatorFinanceiro"
            [exibirPontuacao]="exibirPontuacao"
            [valorTotalPontuacaoProdutosAdicionados]="valorTotalPontuacaoProdutosAdicionados">
          </app-pedido-itens-resumo>
            <section class="pedido-resultado">
              <h2>Resultado do pedido</h2>
              @if (is_master || is_manager || is_diretor) {
                <div class="pedido-margem">{{ porcentagemMarkupPedido | number: '1.2-2' }}%</div><p>Margem geral do pedido</p>
              }
              <div class="pedido-resultado-barra" role="img" aria-label="Indicador visual do resultado do pedido"><span [style.left]="simulacaoResultado"></span></div>
              @if ((is_master || is_diretor) && clienteSelecionado != null) { <button class="btn btn-outline-info" type="button" (click)="abrirAnaliseFinanceiraCliente(resumoFinanceiroModal)">Análise financeira</button> }
            </section>
          </aside>
          <footer class="pedido-itens-footer">
            <button class="btn btn-outline-secondary" type="button" (click)="retornarItemSelecionado(1)">← Voltar</button>
            <div>
              @if (pedidoAprovarExterno) {
                <button class="btn btn-danger" type="button" (click)="reprovar(pedidoReprovar)">Reprovar</button>
                <button class="btn btn-info" type="button" (click)="abrirResumoFinanceiro(resumoFinanceiroModal)">Analisar</button>
                <button class="btn btn-success" type="button" (click)="aprovar()">Aprovar</button>
              }
              <button class="btn btn-primary" type="button" (click)="prosseguirItemSelecionado(1)" [disabled]="calculando">Prosseguir para detalhes →</button>
            </div>
          </footer>
        </div>
      }
    <!-- Detalhes -->
    @if (itemSelecionado == 2) {
      <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="adicionar_itens_qtde">
            <h6 class="text-secondary"><b>Itens:</b></h6>
            <h6><b>{{ produtosAdicionados.length }}</b></h6>
          </div>
          <div class="d-flex flex-wrap">
            <div class="adicionar_itens_valor text-right">
              <h6 class="text-secondary"><b>Peso: (Total)</b></h6>
              <h6><b>{{ valorTotalPesoProdutosAdicionados | currency: 'BRL' : '' }}</b></h6>
            </div>
            @if (exibirFatorFinanceiro) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Fator: R$</b></h6>
                <h6><b>{{ valorTotalProdutosAdicionadosFatorFinanceiro | currency: 'BRL' }}</b></h6>
              </div>
            }
            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Imposto: R$</b></h6>
                <h6><b>{{ valorTotalProdutosAdicionadosImposto | currency: 'BRL' }}</b></h6>
              </div>
            }
            @if (freteValidado && regraFreteAplicavel) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Frete: R$</b></h6>
                <h6><b>{{ valorFrete | currency: 'BRL' }}</b></h6>
              </div>
            }
            <div class="adicionar_itens_valor text-right">
              <h6 class="text-secondary"><b>Total: R$</b></h6>
              <h6><b>{{ valorTotalProdutosAdicionados | currency: 'BRL' }}</b></h6>
            </div>
            @if (exibirPontuacao) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Pontuação:</b></h6>
                <h6><b>{{ valorTotalPontuacaoProdutosAdicionados | number: '1.2-2' }}</b></h6>
              </div>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="form-row">
          <!-- Prazo de Pagamento -->
          @if (configuracao != null && !configuracao.prazo_pagamento_antes_itenspedido && !configuracao.utiliza_fator_financeiro) {
            <div class="form-group col-sm-6">
              <label><b>Prazo de Pagamento:</b></label>
              <app-prazo-pagamento-select
                [prazosIniciais]="prazosPagamentoIniciais"
                [prazosEspeciais]="prazosPagamentoEspeciais"
                [prazoSelecionado]="prazoPagamentoSelecionado"
                [desabilitado]="pedidoAprovarExterno"
                [invalido]="prazoPagamentoInvalido"
                [ocultarTitulosIniciais]="configuracao != null && configuracao.flag_usa_prazo_vinculado_cliente"
                (prazoChange)="alterarPrazoPagamento($event.toString(), false)">
              </app-prazo-pagamento-select>
              @if (prazoPagamentoInvalido) {
                <div class="erro pt-1">Prazo de Pagamento inválido!</div>
              }
            </div>
            <div class="form-group col-sm-2">
              <label><b>Prazo Médio:</b></label>
              <input class="form-control form-control-sm" type="text" name="prazo_medio" [value]="prazoMedio == null || prazoMedio.prazomedio == 0 ? '' : prazoMedio.prazomedio" disabled />
            </div>
            @if (configuracao != null && configuracao.usar_desconto_prazo_medio == 'S') {
              <div class="form-group col-sm-2">
                <label><b>Desconto Máximo: %</b></label>
                <input class="form-control form-control-sm" type="text" name="desconto" [value]="prazoMedioDesconto == null ? '' : prazoMedioDesconto.percentual_desconto" disabled />
              </div>
            }
          }
          <!-- Nro Pedido (Vinculado) -->
          <div class="form-group col-sm-2">
            <label><b>Nro Pedido (Vinculado):</b></label>
            <input class="form-control form-control-sm" type="text" name="pedido_vinculado" maxlength="20" [(ngModel)]="pedidoVinculado" [disabled]="pedidoAprovarExterno" />
          </div>
        </div>
        <!-- Produto(s) c/ Fator Financeiro -->
        @if (exibirFatorFinanceiro) {
          <hr class="mt-2 mb-2" />
          <div class="quadro_produtos p-2">
            <div class="text-center pb-2">
              <b>Produto(s) c/ Fator Financeiro ({{ prazoPagamentoSelecionado.fator_financeiro | currency: 'BRL' : '' }}%)</b>
            </div>
            <div class="bg-white">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th colspan="5"></th>
                        <th></th>
                        <th class="tabela_borda text-center"><b>C/ Fator</b></th>
                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                          <th class="tabela_borda"></th>
                        }
                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                          <th class="tabela_borda text-center"><b>C/ Imposto</b></th>
                        }
                        <th class="tabela_borda"></th>
                        @if (exibirPontuacao) {
                          <th class="tabela_borda"></th>
                        }
                      </tr>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center tabela_borda">Código</th>
                        <th class="tabela_borda">Descrição</th>
                        <th class="text-center tabela_borda">Qtde</th>
                        <th class="text-right tabela_borda">Unitário: R$</th>
                        <th class="text-right tabela_borda">Fator: R$</th>
                        <th class="text-right tabela_borda">Sub-Total: R$</th>
                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                          <th class="text-right tabela_borda">Imposto: R$</th>
                        }
                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                          <th class="text-right tabela_borda">Sub-Total: R$</th>
                        }
                        <th class="text-right tabela_borda">Unitário (Final): R$</th>
                        @if (exibirPontuacao) {
                          <th class="text-right tabela_borda">Pontuação</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *cdkVirtualFor="let produtoAdicionado of produtosAdicionados; let i = index; templateCacheSize: 0;">
                        <tr [ngClass]="valorFatorItem(produtoAdicionado) > 0 ? 'bg_tabela_info' : ''">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center tabela_borda">{{ produtoAdicionado.codigo }}</td>
                          <td class="tabela_borda">
                            {{ produtoAdicionado.name }}
                            @if (produtoAdicionado.qtde_bonificada > 0) {
                              <span class="badge badge-success produto_qtde_bonificada">
                                <b>+{{ produtoAdicionado.qtde_bonificada }} {{ produtoAdicionado.qtde_bonificada > 1 ? 'UNIDADES' : 'UNIDADE' }} BONIFICADA</b>
                              </span>
                            }
                          </td>
                          <td class="text-center tabela_borda">{{ produtoAdicionado.qtde == null || produtoAdicionado.qtde == 0 ? '-' : produtoAdicionado.qtde }}</td>
                          <td class="text-right tabela_borda"><b>{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor) }}</b></td>
                          <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produtoAdicionado), false, true) }}</td>
                          <td class="text-right tabela_borda"><b>{{ produtoAdicionado.valor_fator_financeiro_total | currency: 'BRL' }}</b></td>
                          @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                            <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor_imposto_unitario) }}</td>
                          }
                          @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                            <td class="text-right tabela_borda"><b>{{ produtoAdicionado.valor_imposto_total_final | currency: 'BRL' }}</b></td>
                          }
                          <td class="text-right tabela_borda"><b>{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor_unitario_final) }}</b></td>
                          @if (exibirPontuacao) {
                            <td class="text-right tabela_borda"><b>{{ produtoAdicionado.pontuacao_calculada | number: '1.2-2' }}</b></td>
                          }
                        </tr>
                        @if (produtoAdicionado.produtos_vinculados != null) {
                          <tr>
                            <td class="p-3" colspan="10">
                              <table class="table table-sm table-hover">
                                <thead>
                                  <tr>
                                    <th colspan="4"></th>
                                    <th></th>
                                    <th class="tabela_borda text-center"><b>C/ Fator</b></th>
                                    @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                      <th class="tabela_borda"></th>
                                    }
                                    @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                      <th class="tabela_borda text-center"><b>C/ Imposto</b></th>
                                    }
                                    <th class="tabela_borda"></th>
                                  </tr>
                                  <tr>
                                    <th class="text-center">Código</th>
                                    <th class="tabela_borda">Descrição</th>
                                    <th class="text-center tabela_borda">Qtde</th>
                                    <th class="text-right tabela_borda">Unitário: R$</th>
                                    <th class="text-right tabela_borda">Fator: R$</th>
                                    <th class="text-right tabela_borda">Sub-Total: R$</th>
                                    @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                      <th class="text-right tabela_borda">Imposto: R$</th>
                                    }
                                    @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                      <th class="text-right tabela_borda">Sub-Total: R$</th>
                                    }
                                    <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (produto_vinculado of produtoAdicionado.produtos_vinculados; track produto_vinculado) {
                                    @if (produto_vinculado.qtde > 0 && (!produto_vinculado.bonificacao || (produto_vinculado.bonificacao && produto_vinculado.bonificacao_selecionada))) {
                                      <tr [ngClass]="valorFatorItem(produto_vinculado) > 0 ? 'bg_tabela_info' : ''">
                                        <td class="text-center">{{ produto_vinculado.codigo }}</td>
                                        <td class="tabela_borda">
                                          {{ produto_vinculado.name }}
                                          @if (produtoAdicionado.preco_bonificacao == 'B' && produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                            <span class="badge badge-success produto_campanha_bonificado"><b> BONIFICAÇÃO</b></span>
                                          }
                                          @if (produtoAdicionado.preco_bonificacao == 'B' && !produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                            <span class="badge badge-success produto_campanha_bonificado">
                                              @if (!produtoAdicionado.bonificacao_multiplicavel) {
                                                +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} UNIDADE GRÁTIS
                                              }
                                              @if (produtoAdicionado.bonificacao_multiplicavel) {
                                                +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} {{ produtoAdicionado.qtde_bonificacao_multiplicavel > 1 ? 'UNIDADES' : 'UNIDADE' }} GRÁTIS
                                              }
                                            </span>
                                          }
                                        </td>
                                        <td class="text-center tabela_borda">{{ produto_vinculado.qtde }}</td>
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span><b>{{ produto_vinculado.valor | currency: 'BRL' }}</b></span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span><b>{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produto_vinculado)) }}</b></span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span>{{ produto_vinculado.valor_fator_financeiro_total | currency: 'BRL' }}</span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                          <td class="text-right tabela_borda">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_imposto_unitario) }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                          <td class="text-right tabela_borda">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ produto_vinculado.valor_imposto_total_final | currency: 'BRL' }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_unitario_final) }}</b></span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                      </tr>
                                    }
                                  }
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        }
                      </ng-container>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
        }
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>Observação Interna:</b></label>
            <textarea class="form-control form-control-sm" rows="2" name="observacaoInterna" [(ngModel)]="observacaoInterna" [disabled]="pedidoAprovarExterno"></textarea>
          </div>
          <div class="form-group col-sm-6">
            <label><b>Observação Nota Fiscal:</b></label>
            <textarea class="form-control form-control-sm" rows="2" name="observacaoNotaFiscal" [(ngModel)]="observacaoNotaFiscal" [disabled]="pedidoAprovarExterno"></textarea>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 formulario_rodape">
            <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(2)">Retornar</button>
          </div>
          <div class="flex-grow-1 formulario_rodape text-right">
            <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(2)">Prosseguir</button>
            @if (pedidoAprovarExterno) {
              <button class="btn btn-danger btn_formulario" type="button" (click)="reprovar(pedidoReprovar)">Reprovar</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirResumoFinanceiro(resumoFinanceiroModal)">Analisar</button>
            }
            @if ((is_master || is_diretor) && clienteSelecionado != null) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirAnaliseFinanceiraCliente(resumoFinanceiroModal)">Análise Financeira</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-success btn_formulario" type="button" (click)="aprovar()">Aprovar</button>
            }
          </div>
        </div>
      </div>
    }
    <!-- Confirmação -->
    @if (itemSelecionado == 3) {
      <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
        <!-- Dados (Cliente) -->
        <div class="quadro_confirmacao_cabecalho p-2">
          <div class="d-flex justify-content-between">
            @if (nroPedidoOrcamento != 0) {
              <div class="mr-4">
                <h6 class="text-secondary"><b>Número:</b></h6>
                <h6><b>{{ nroPedidoOrcamento }}</b></h6>
              </div>
            }
            <div class="mr-4">
              <h6 class="text-secondary"><b>Data:</b></h6>
              <h6><b>{{ dataAtual | date: 'dd/MM/yyyy HH:mm:ss' }}</b></h6>
            </div>
            <div class="flex-grow-1">
              <h6 class="text-secondary"><b>Cliente:</b></h6>
              <h6><b>{{ clienteSelecionado.name }}</b></h6>
              <h6><b>{{ clienteSelecionado.endereco_completo }}</b></h6>
            </div>
          </div>
        </div>
        <div class="d-flex">
          @if (clienteSelecionado.phone != null && clienteSelecionado.phone != '') {
            <div class="flex-grow-1 quadro_confirmacao_cabecalho mt-1 p-2">
              <h6 class="text-secondary"><b>Telefone:</b></h6>
              <h6><b>{{ clienteSelecionado.phone }}</b></h6>
            </div>
          }
          @if (clienteSelecionado.email != null && clienteSelecionado.email != '') {
            <div class="flex-grow-1 quadro_confirmacao_cabecalho mt-1 ml-1 p-2">
              <h6 class="text-secondary"><b>E-mail:</b></h6>
              <h6><b>{{ clienteSelecionado.email }}</b></h6>
            </div>
          }
          @if (clienteSelecionado.responsible_name != null && clienteSelecionado.responsible_name != '') {
            <div class="flex-grow-1 quadro_confirmacao_cabecalho mt-1 ml-1 p-2">
              <h6 class="text-secondary"><b>Contato:</b></h6>
              <h6><b>{{ clienteSelecionado.responsible_name }}</b></h6>
            </div>
          }
          @if (clienteSelecionado.client_document != null && clienteSelecionado.client_document != '') {
            <div class="flex-grow-1 quadro_confirmacao_cabecalho mt-1 ml-1 p-2">
              <h6 class="text-secondary"><b>CNPJ/CPF:</b></h6>
              <h6><b>{{ clienteSelecionado.client_document }}</b></h6>
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap">
          <!-- Orçamento/Pedido -->
          <div class="confirmacao_item mb-1 mr-1 p-1">
            <h6 class="text-secondary"><b>Orçamento/Pedido:</b></h6>
            <h6><b>{{ pedidoOrcamentoSelecionado == 0 ? 'Orçamento' : 'Pedido' }}</b></h6>
          </div>
          <!-- Canal de Vendas -->
          <div class="confirmacao_item mb-1 mr-1 p-1">
            <h6 class="text-secondary"><b>Canal de Vendas:</b></h6>
            <h6><b>{{ canalVendasSelecionado == 3 ? 'E-mail' : canalVendasSelecionado == 2 ? 'Telefone' : 'Whatsapp' }}</b></h6>
          </div>
          <!-- Vendedor(a) -->
          <div class="confirmacao_item mb-1 mr-1 p-1">
            <h6 class="text-secondary"><b>Vendedor(a):</b></h6>
            <h6><b>{{ vendedorSelecionado.fullname }} - {{ vendedorSelecionado.celular }}</b></h6>
          </div>
          <!-- Tipo de Pedido -->
          <div class="confirmacao_item mb-1 mr-1 p-1">
            <h6 class="text-secondary"><b>Tipo de Pedido:</b></h6>
            <h6><b>{{ tiposPedidoSelecionado.descricao }}</b></h6>
          </div>
          <!-- Transportadora -->
          @if (configuracao != null && configuracao.seleciona_transportadora) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Transportadora:</b></h6>
              <h6><b>{{ transportadoraSelecionada.nm_transportadora }}</b></h6>
            </div>
          }
          @if (configuracao != null && !configuracao.seleciona_transportadora && clienteSelecionado != null && clienteSelecionado.nm_transportadora != null) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Transportadora:</b></h6>
              <h6><b>{{ clienteSelecionado.nm_transportadora }}</b></h6>
            </div>
          }
          <!-- Frete -->
          <div class="confirmacao_item mb-1 mr-1 p-1">
            <h6 class="text-secondary"><b>Frete:</b></h6>
            <h6><b>{{ tipoFreteSelecionado.descricao }}</b></h6>
          </div>
          <!-- Empresa -->
          @if (produtoReferenciaClienteSelecionado != null && produtoReferenciaClienteSelecionado != '') {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Empresa:</b></h6>
              <h6><b>{{ produtoReferenciaClienteSelecionado }}</b></h6>
            </div>
          }
          <!-- Forma de Pagamento -->
          @if (formasPagamento.length > 0) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Forma de Pagamento:</b></h6>
              <h6><b>{{ formaPagamentoSelecionada.descricao }}</b></h6>
            </div>
          }
          <!-- Dt. Validade -->
          @if (dataValidade != null && dataValidade.year != null && dataValidade.month != null && dataValidade.day != null) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Dt. Validade:</b></h6>
              <h6><b>{{ dataValidade.day.toString().padStart(2, "0") }}/{{ dataValidade.month.toString().padStart(2, "0") }}/{{ dataValidade.year }}</b></h6>
            </div>
          }
          <!-- Pedido Programado -->
          @if (dataPrevisaoEntrega != null && dataPrevisaoEntrega.year != null && dataPrevisaoEntrega.month != null && dataPrevisaoEntrega.day != null) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Pedido Programado:</b></h6>
              <h6><b>{{ dataPrevisaoEntrega.day.toString().padStart(2, "0") }}/{{ dataPrevisaoEntrega.month.toString().padStart(2, "0") }}/{{ dataPrevisaoEntrega.year }}</b></h6>
            </div>
          }
          <!-- Local de Entrega -->
          @if (configuracao != null && configuracao.exibe_local_entrega && clienteLocalEntregaSelecionado != null) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Local de entrega:</b></h6>
              <h6><b>{{ clienteLocalEntregaSelecionado.localentrega }}</b></h6>
            </div>
          }
          <!-- Prazo de Pagamento -->
          @if (prazoPagamentoSelecionado != null) {
            <div class="confirmacao_item mb-1 mr-1 p-1">
              <h6 class="text-secondary"><b>Prazo de Pagamento:</b></h6>
              <h6><b>{{ prazoPagamentoSelecionado.descricao }}</b></h6>
            </div>
          }
        </div>
        <table class="table table-sm">
          <tr>
            <td>
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center tabela_borda">Código</th>
                        <th class="tabela_borda">Descrição</th>
                        <th class="text-center tabela_borda">Grupo Estoque</th>
                        <th class="text-center tabela_borda">Qtde</th>
                        <th class="text-right tabela_borda">Unitário: R$</th>
                        @if (exibirFatorFinanceiro) {
                          <th class="text-right tabela_borda">Fator: R$</th>
                        }
                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                          <th class="text-right tabela_borda">Imposto: R$</th>
                        }
                        @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                          <th class="text-right tabela_borda">Unitário (Final): R$</th>
                        }
                        <th class="text-right tabela_borda">Sub-Total: R$</th>
                        @if (exibirPontuacao) {
                          <th class="text-right tabela_borda">Pontuação</th>
                        }
                        <th class="text-right tabela_borda">Tabela: R$</th>
                        <th class="text-right tabela_borda">Desconto: %</th>
                        <th class="tabela_borda">Observação</th>
                        <th class="text-center tabela_borda text-secondary">Última Compra</th>
                        <th class="text-right tabela_borda text-secondary">Unitário: R$</th>
                        <th class="text-right tabela_borda text-secondary">Desconto: %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *cdkVirtualFor="let produtoAdicionado of produtosAdicionados; let i = index; templateCacheSize: 0;">
                        <tr>
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center tabela_borda">{{ produtoAdicionado.codigo }}</td>
                          <td class="tabela_borda">
                            {{ produtoAdicionado.name }}
                            @if (produtoAdicionado.qtde_bonificada > 0) {
                              <span class="badge badge-success produto_qtde_bonificada">
                                <b>+{{ produtoAdicionado.qtde_bonificada }} {{ produtoAdicionado.qtde_bonificada > 1 ? 'UNIDADES' : 'UNIDADE' }} BONIFICADA</b>
                              </span>
                            }
                          </td>
                          <td class="text-center tabela_borda">{{ produtoAdicionado.grupo_estoque }}</td>
                          <td class="text-center tabela_borda">{{ produtoAdicionado.qtde == null || produtoAdicionado.qtde == 0 ? '-' : produtoAdicionado.qtde }}</td>
                          <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor) }}</td>
                          @if (exibirFatorFinanceiro) {
                            <td class="text-right tabela_borda"><b>{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produtoAdicionado), false, true) }}</b></td>
                          }
                          @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                            <td class="text-right tabela_borda"><b>{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor_imposto_unitario) }}</b></td>
                          }
                          @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                            <td class="text-right tabela_borda"><b>{{ formatarValoresQuatroCasasDecimais(produtoAdicionado.valor_unitario_final) }}</b></td>
                          }
                          <td class="text-right tabela_borda"><b>{{ produtoAdicionado.valor_imposto_total_final | currency: 'BRL' }}</b></td>
                          @if (exibirPontuacao) {
                            <td class="text-right tabela_borda"><b>{{ produtoAdicionado.pontuacao_calculada | number: '1.2-2' }}</b></td>
                          }
                          @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                            <td class="text-right tabela_borda">{{ produtoAdicionado.price | currency: 'BRL' }}</td>
                          }
                          @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                            <td class="text-right tabela_borda">{{ (produtoAdicionado.grupo_estoque == this.combo ? produtoAdicionado.valor_tabela : produtoAdicionado.price) | currency: 'BRL' }}</td>
                          }
                          <td class="text-right tabela_borda">{{ produtoAdicionado.porcentagem_desconto_temporaria != null ? formatarValoresQuatroCasasDecimais(produtoAdicionado.porcentagem_desconto_temporaria, true) : (produtoAdicionado.porcentagem_desconto | currency: 'BRL' : '') }}%</td>
                          <td class="tabela_borda">{{ produtoAdicionado.descritivo_desconto }}</td>
                          <td class="text-center tabela_borda text-secondary">{{ produtoAdicionado.ultima_compra | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                          <td class="text-right tabela_borda text-secondary">{{ (produtoAdicionado.preco_faturado != null && produtoAdicionado.preco_faturado != 0 ? produtoAdicionado.preco_faturado : produtoAdicionado.unit_price) | currency: 'BRL' }}</td>
                          <td class="text-right tabela_borda text-secondary">
                            @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos && produtoAdicionado.desc_aplicado != null) {
                              <div>
                                {{ produtoAdicionado.desc_aplicado | currency: 'BRL' : '' }}%
                              </div>
                            }
                            @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos && produtoAdicionado.desc_aplicado2 != null) {
                              <div>
                                {{ produtoAdicionado.desc_aplicado2 | currency: 'BRL' : '' }}%
                              </div>
                            }
                          </td>
                        </tr>
                        @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && produtoAdicionado.observacao_item != null && produtoAdicionado.observacao_item != '') {
                          <tr>
                            <td></td>
                            <td></td>
                            <td class="tabela_borda" colspan="14">
                              {{ produtoAdicionado.observacao_item }}
                            </td>
                          </tr>
                        }
                        @if (produtoAdicionado.produtos_vinculados != null) {
                          <tr>
                            <td class="p-3" colspan="16">
                              <table class="table table-sm table-hover">
                                <thead>
                                  <tr>
                                    <th class="text-center">Código</th>
                                    <th class="tabela_borda">Descrição</th>
                                    <th class="text-center tabela_borda">Qtde</th>
                                    <th class="text-right tabela_borda">Unitário: R$</th>
                                    @if (exibirFatorFinanceiro) {
                                      <th class="text-right tabela_borda">Fator: R$</th>
                                    }
                                    @if (exibirFatorFinanceiro) {
                                      <th class="text-right tabela_borda bg_tabela_danger">C/ Fator: R$</th>
                                    }
                                    @if (exibirPontuacao) {
                                      <th class="text-right tabela_borda bg_tabela_warning">Pontuação</th>
                                    }
                                    @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                      <th class="text-right tabela_borda">Imposto: R$</th>
                                    }
                                    @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                      <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                    }
                                    <th class="text-right tabela_borda">Sub-Total: R$</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (produto_vinculado of produtoAdicionado.produtos_vinculados; track produto_vinculado) {
                                    @if (produto_vinculado.qtde > 0 && (!produto_vinculado.bonificacao || (produto_vinculado.bonificacao && produto_vinculado.bonificacao_selecionada))) {
                                      <tr>
                                        <td class="text-center">{{ produto_vinculado.codigo }}</td>
                                        <td class="tabela_borda">
                                          {{ produto_vinculado.name }}
                                          @if (produtoAdicionado.preco_bonificacao == 'B' && produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                            <span class="badge badge-success produto_campanha_bonificado"><b> BONIFICAÇÃO</b></span>
                                          }
                                          @if (produtoAdicionado.preco_bonificacao == 'B' && !produtoAdicionado.bonificacao_selecionavel && produto_vinculado.bonificacao_selecionada) {
                                            <span class="badge badge-success produto_campanha_bonificado">
                                              @if (!produtoAdicionado.bonificacao_multiplicavel) {
                                                +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} UNIDADE GRÁTIS
                                              }
                                              @if (produtoAdicionado.bonificacao_multiplicavel) {
                                                +{{ produtoAdicionado.qtde_bonificacao_multiplicavel }} {{ produtoAdicionado.qtde_bonificacao_multiplicavel > 1 ? 'UNIDADES' : 'UNIDADE' }} GRÁTIS
                                              }
                                            </span>
                                          }
                                        </td>
                                        <td class="text-center tabela_borda">{{ produto_vinculado.qtde }}</td>
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span>{{ produto_vinculado.price_promotional | currency: 'BRL' }}</span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                        @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                          <td class="text-right tabela_borda">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_imposto_unitario) }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        @if (exibirFatorFinanceiro) {
                                          <td class="text-right tabela_borda">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ formatarValoresQuatroCasasDecimais(valorFatorItem(produto_vinculado)) }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        @if (exibirFatorFinanceiro) {
                                          <td class="text-right tabela_borda bg_tabela_danger">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ produto_vinculado.valor_fator_financeiro_produto | currency: 'BRL' }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        @if (exibirPontuacao) {
                                          <td class="text-right tabela_borda bg_tabela_warning">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ produto_vinculado.pontuacao_calculada | number: '1.2-2' }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                          <td class="text-right tabela_borda">
                                            @if (!produto_vinculado.bonificacao) {
                                              <span><b>{{ formatarValoresQuatroCasasDecimais(produto_vinculado.valor_unitario_final) }}</b></span>
                                            }
                                            @if (produto_vinculado.bonificacao) {
                                              <span>-</span>
                                            }
                                          </td>
                                        }
                                        <td class="text-right tabela_borda">
                                          @if (!produto_vinculado.bonificacao) {
                                            <span><b>{{ produto_vinculado.valor_imposto_total_final | currency: 'BRL' }}</b></span>
                                          }
                                          @if (produto_vinculado.bonificacao) {
                                            <span>-</span>
                                          }
                                        </td>
                                      </tr>
                                    }
                                  }
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        }
                      </ng-container>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </td>
          </tr>
          @if (pedidoItensInativos.length > 0) {
            <tr>
              <td class="text-center" colspan="16">
                <b>Bonificação Vinculada</b>
              </td>
            </tr>
          }
          @if (pedidoItensInativos.length > 0) {
            <tr>
              <td>
                <div class="table-responsive">
                  <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th class="text-center">#</th>
                          <th class="text-center tabela_borda">Código</th>
                          <th class="tabela_borda">Descrição</th>
                          <th class="text-center tabela_borda">Qtde</th>
                          <th class="text-right tabela_borda">Unitário: R$</th>
                          <th class="text-right tabela_borda">Total: R$</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *cdkVirtualFor="let pedidoItemInativo of pedidoItensInativos; let i = index; templateCacheSize: 0;">
                          <tr>
                            <td class="text-center">{{ i + 1 }}</td>
                            <td class="text-center tabela_borda">{{ pedidoItemInativo.produto_codigo }}</td>
                            <td class="tabela_borda">{{ pedidoItemInativo.produto_nome }}</td>
                            <td class="text-center tabela_borda">{{ pedidoItemInativo.quantity }}</td>
                            <td class="text-right tabela_borda">{{ pedidoItemInativo.unit_price | currency: 'BRL' }}</td>
                            <td class="text-right tabela_borda">{{ pedidoItemInativo.total | currency: 'BRL' }}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </cdk-virtual-scroll-viewport>
                </div>
              </td>
            </tr>
          }
        </table>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <!-- Observações -->
          <div>
            @if (observacaoInterna != null && observacaoInterna != '') {
              <div>
                <h6 class="text-secondary"><b>Observação Interna:</b></h6>
                <h6><b>{{ observacaoInterna }}</b></h6>
              </div>
            }
            @if (observacaoNotaFiscal != null && observacaoNotaFiscal != '') {
              <div>
                <h6 class="text-secondary"><b>Observação Nota Fiscal:</b></h6>
                <h6><b>{{ observacaoNotaFiscal }}</b></h6>
              </div>
            }
          </div>
          <!-- Valores -->
          <div class="d-flex flex-wrap">
            <div class="adicionar_itens_valor text-right">
              <h6 class="text-secondary"><b>Peso: (Total)</b></h6>
              <h6><b>{{ valorTotalPesoProdutosAdicionados | currency: 'BRL' : '' }}</b></h6>
            </div>
            @if (exibirFatorFinanceiro) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Fator: R$</b></h6>
                <h6><b>{{ valorTotalProdutosAdicionadosFatorFinanceiro | currency: 'BRL' }}</b></h6>
              </div>
            }
            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Imposto: R$</b></h6>
                <h6><b>{{ valorTotalProdutosAdicionadosImposto | currency: 'BRL' }}</b></h6>
              </div>
            }
            @if (freteValidado && regraFreteAplicavel) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Frete: R$</b></h6>
                <h6><b>{{ valorFrete | currency: 'BRL' }}</b></h6>
              </div>
            }
            <div class="adicionar_itens_valor text-right">
              <h6 class="text-secondary"><b>Total: R$</b></h6>
              <h6><b>{{ valorTotalProdutosAdicionados | currency: 'BRL' }}</b></h6>
            </div>
            @if (exibirPontuacao) {
              <div class="adicionar_itens_valor text-right">
                <h6 class="text-secondary"><b>Pontuação:</b></h6>
                <h6><b>{{ valorTotalPontuacaoProdutosAdicionados | number: '1.2-2' }}</b></h6>
              </div>
            }
          </div>
        </div>
        <!-- Histórico -->
        @if (pedidoAprovarExterno) {
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-column quadro_confirmacao_historico p-2">
            <div class="text-center mb-2">
              <h6 class="mb-2"><b>Histórico</b></h6>
            </div>
            <div class="text-center mb-2 mt-2 quadro_confirmacao_historico_separador">
              <h6 class="mb-2 pt-2"><b>Status</b></h6>
            </div>
            <div class="table-responsive bg-white mb-2">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="text-center">Data</th>
                    <th class="tabela_borda">Observação</th>
                  </tr>
                </thead>
                <tbody>
                  @for (pedidoStatus of pedidosStatus; track pedidoStatus) {
                    <tr>
                      <td class="text-center">{{ pedidoStatus.data | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                      <td class="tabela_borda">{{ pedidoStatus.obs }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="text-center mb-2 mt-2 quadro_confirmacao_historico_separador">
              <h6 class="mb-2 pt-2"><b>Pedidos</b></h6>
            </div>
            <ul ngbNav #t="ngbNav" class="nav-tabs">
              <!-- Pedidos Aguard Financeiro (Cliente) -->
              @if (pedidosAguardFinanceiroClientes.length> 0) {
                <li [ngbNavItem]="'tab-aguard-financeiro'">
                  <a ngbNavLink>
                    <b>Aguard Aprovação</b>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="bg-white pt-3">
                      @if (modelo_tela_ligacoes == 0) {
                        <!-- Modelo 1 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="tabela_borda">Vend Externo</th>
                                <th class="tabela_borda">Vend Interno</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Litragem</th>
                                <th class="text-center tabela_borda">Enviado</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoAguardFinanceiro of pedidosAguardFinanceiroClientes; track pedidoAguardFinanceiro; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensAguardFinanceiroExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensAguardFinanceiro(i, pedidoAguardFinanceiro.order_id_app)"></i>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    <span class="badge badge-financeiro">{{ pedidoAguardFinanceiro.status_pedido }}</span>
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.order_id_app }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.vend_ext }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.vend_int }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoAguardFinanceiro.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoAguardFinanceiro.total_litragem | currency: 'BRL' : '' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.order_sent_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.cod_tipopedvenda }}</td>
                                </tr>
                                @if (i == pedidosItensAguardFinanceiroExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="11">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              @if (exibirFatorFinanceiroAguardFinanceiro) {
                                                <th class="text-right tabela_borda">Fator: R$</th>
                                              }
                                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                <th class="text-right tabela_borda">Imposto: R$</th>
                                              }
                                              @if (exibirFatorFinanceiroAguardFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                              }
                                              <th class="text-right tabela_borda">Sub-Total: R$</th>
                                              @if (is_master || is_manager || is_diretor) {
                                                <th class="text-right tabela_borda">Margem: %</th>
                                              }
                                              <th class="text-right tabela_borda">Tabela: R$</th>
                                              <th class="tabela_borda">Promoção</th>
                                              <th class="text-right tabela_borda">Preço Promoção: R$</th>
                                              <th class="text-right tabela_borda">Desconto: R$</th>
                                              <th class="text-right tabela_borda">Desconto: %</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemAguardFinanceiro of pedidosItensAguardFinanceiro; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemAguardFinanceiro.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemAguardFinanceiro.produto }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemAguardFinanceiro.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemAguardFinanceiro.vr_unitario_original) }}</td>
                                                @if (exibirFatorFinanceiroAguardFinanceiro) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.fator_financeiro | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.valor_imposto | currency: 'BRL' }}</td>
                                                }
                                                @if (exibirFatorFinanceiroAguardFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.vr_unitario_acumulado | currency: 'BRL' }}</td>
                                                }
                                                <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                @if (is_master || is_manager || is_diretor) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.mkt | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ (pedidoItemAguardFinanceiro._api_preco_tabela || pedidoItemAguardFinanceiro.preco_tabela) | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ (pedidoItemAguardFinanceiro._api_precotabela2 || pedidoItemAguardFinanceiro.precotabela2) | currency: 'BRL' }}</td>
                                                }
                                                <td class="tabela_borda">{{ pedidoItemAguardFinanceiro.nome_promocao }}</td>
                                                <td class="text-right tabela_borda">{{ (pedidoItemAguardFinanceiro._api_preco_tabela || pedidoItemAguardFinanceiro.preco_tabela) | currency: 'BRL' }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.valor_desconto | currency: 'BRL' }}</td>
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.desc_aplicado | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                                                }
                                              </tr>
                                              @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItemAguardFinanceiro.observacao_item != null && pedidoItemAguardFinanceiro.observacao_item != '') {
                                                <tr>
                                                  <td></td>
                                                  <td class="tabela_borda" colspan="14">
                                                    {{ pedidoItemAguardFinanceiro.observacao_item }}
                                                  </td>
                                                </tr>
                                              }
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoAguardFinanceiro.observacao_interna != null && pedidoAguardFinanceiro.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="12"><b>Observação Interna:</b> {{ pedidoAguardFinanceiro.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoAguardFinanceiro.observacao_nf != null && pedidoAguardFinanceiro.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="12"><b>Observação Nota Fiscal:</b> {{ pedidoAguardFinanceiro.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (modelo_tela_ligacoes == 1) {
                        <!-- Modelo 2 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Volume Total: R$</th>
                                <th class="text-center tabela_borda">Data do Pedido</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                                <th class="text-center tabela_borda">Nota Fiscal</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoAguardFinanceiro of pedidosAguardFinanceiroClientes; track pedidoAguardFinanceiro; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensAguardFinanceiroExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensAguardFinanceiro(i, pedidoAguardFinanceiro.order_id_app)"></i>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    <span class="badge badge-financeiro">{{ pedidoAguardFinanceiro.status_pedido }}</span>
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.id_no_erp_do_cliente }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoAguardFinanceiro.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoAguardFinanceiro.total_volume | currency: 'BRL' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="tabela_borda">{{ pedidoAguardFinanceiro.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.cod_tipopedvenda }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoAguardFinanceiro.numero_nf }}</td>
                                </tr>
                                @if (i == pedidosItensAguardFinanceiroExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="10">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="text-center tabela_borda">Sku</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="tabela_borda">Marca</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              <th class="text-right tabela_borda">Total: R$</th>
                                              <th class="text-right tabela_borda">Volume: R$</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemAguardFinanceiro of pedidosItensAguardFinanceiro; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemAguardFinanceiro.codigo }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemAguardFinanceiro.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemAguardFinanceiro.produto }}</td>
                                                <td class="tabela_borda">{{ pedidoItemAguardFinanceiro.grupo_estoque }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemAguardFinanceiro.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemAguardFinanceiro.vr_unitario_original) }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemAguardFinanceiro.volume | currency: 'BRL' }}</td>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoAguardFinanceiro.observacao_interna != null && pedidoAguardFinanceiro.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedidoAguardFinanceiro.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoAguardFinanceiro.observacao_nf != null && pedidoAguardFinanceiro.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedidoAguardFinanceiro.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                    </div>
                  </ng-template>
                </li>
              }
              <!-- Pedidos Enviados (Cliente) -->
              <li [ngbNavItem]="'tab-enviados'">
                <a ngbNavLink>
                  <b>Enviados</b>
                </a>
                <ng-template ngbNavContent>
                  <div class="bg-white pt-3">
                    @if (modelo_tela_ligacoes == 0) {
                      <!-- Modelo 1 -->
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-center tabela_borda">Status</th>
                              <th class="text-center tabela_borda">Nro Pedido</th>
                              <th class="tabela_borda">Vend Externo</th>
                              <th class="tabela_borda">Vend Interno</th>
                              <th class="tabela_borda">Cliente</th>
                              <th class="text-right tabela_borda">Total: R$</th>
                              <th class="text-right tabela_borda">Litragem</th>
                              <th class="text-center tabela_borda">Enviado</th>
                              <th class="tabela_borda">Prazo Pagto</th>
                              <th class="text-center tabela_borda">Tipo</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (pedidoEnviadoCliente of pedidosEnviadosClientes; track pedidoEnviadoCliente; let i = $index) {
                              <tr>
                                <td class="text-center tabela_acao">
                                  <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensEnviados(i, pedidoEnviadoCliente.order_id_app)"></i>
                                </td>
                                <td class="text-center tabela_borda">
                                  @if (pedidoEnviadoCliente.status_pedido == 'À Integrar') {
                                    <span class="badge badge-primary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Aprov') {
                                    <span class="badge badge-warning">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Financeiro') {
                                    <span class="badge badge-financeiro">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Cad') {
                                    <span class="badge badge-secondary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Erro Integ') {
                                    <span class="badge badge-danger">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Faturado') {
                                    <span class="badge badge-info">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Faturado Div') {
                                    <span class="badge badge-other">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Integrado') {
                                    <span class="badge badge-success">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Reprovado') {
                                    <span class="badge badge-dark">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                </td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_id_app }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.vend_ext }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.vend_int }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.name }}</td>
                                <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total | currency: 'BRL' }}</td>
                                <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total_litragem | currency: 'BRL' : '' }}</td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_sent_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.prazo_pgto }}</td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.cod_tipopedvenda }}</td>
                              </tr>
                              @if (i == pedidosItensEnviadosExpandido) {
                                <tr [@esvanecerDesvanecer]="'in'">
                                  <td class="p-3" colspan="11">
                                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                      <table class="table table-sm table-hover">
                                        <thead>
                                          <tr>
                                            <th class="text-center">Código</th>
                                            <th class="tabela_borda">Descrição</th>
                                            <th class="text-center tabela_borda">Qtde</th>
                                            <th class="text-right tabela_borda">Unitário: R$</th>
                                            @if (exibirFatorFinanceiroEnviados) {
                                              <th class="text-right tabela_borda">Fator: R$</th>
                                            }
                                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                              <th class="text-right tabela_borda">Imposto: R$</th>
                                            }
                                            @if (exibirFatorFinanceiroEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                              <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                            }
                                            <th class="text-right tabela_borda">Sub-Total: R$</th>
                                            @if (is_master || is_manager || is_diretor) {
                                              <th class="text-right tabela_borda">Margem: %</th>
                                            }
                                            <th class="text-right tabela_borda">Tabela: R$</th>
                                            <th class="tabela_borda">Promoção</th>
                                            <th class="text-right tabela_borda">Preço Promoção: R$</th>
                                            <th class="text-right tabela_borda">Desconto: R$</th>
                                            <th class="text-right tabela_borda">Desconto: %</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *cdkVirtualFor="let pedidoItemEnviado of pedidosItensEnviados; templateCacheSize: 0;">
                                            <tr>
                                              <td class="text-center">{{ pedidoItemEnviado.referencia_cliente }}</td>
                                              <td class="tabela_borda">{{ pedidoItemEnviado.produto }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemEnviado.quantity }}</td>
                                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemEnviado.vr_unitario_original) }}</td>
                                              @if (exibirFatorFinanceiroEnviados) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.fator_financeiro | currency: 'BRL' }}</td>
                                              }
                                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.valor_imposto | currency: 'BRL' }}</td>
                                              }
                                              @if (exibirFatorFinanceiroEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_unitario_acumulado | currency: 'BRL' }}</td>
                                              }
                                              <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                              @if (is_master || is_manager || is_diretor) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.mkt | currency: 'BRL' : '' }}%</td>
                                              }
                                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ (pedidoItemEnviado._api_preco_tabela || pedidoItemEnviado.preco_tabela) | currency: 'BRL' }}</td>
                                              }
                                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ (pedidoItemEnviado._api_precotabela2 || pedidoItemEnviado.precotabela2) | currency: 'BRL' }}</td>
                                              }
                                              <td class="tabela_borda">{{ pedidoItemEnviado.nome_promocao }}</td>
                                              <td class="text-right tabela_borda">{{ (pedidoItemEnviado._api_preco_tabela || pedidoItemEnviado.preco_tabela) | currency: 'BRL' }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemEnviado.valor_desconto | currency: 'BRL' }}</td>
                                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.desc_aplicado | currency: 'BRL' : '' }}%</td>
                                              }
                                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                                              }
                                            </tr>
                                            @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItemEnviado.observacao_item != null && pedidoItemEnviado.observacao_item != '') {
                                              <tr>
                                                <td></td>
                                                <td class="tabela_borda" colspan="14">
                                                  {{ pedidoItemEnviado.observacao_item }}
                                                </td>
                                              </tr>
                                            }
                                          </ng-container>
                                        </tbody>
                                        <tfoot>
                                          @if (pedidoEnviadoCliente.observacao_interna != null && pedidoEnviadoCliente.observacao_interna != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="12"><b>Observação Interna:</b> {{ pedidoEnviadoCliente.observacao_interna }}</td>
                                            </tr>
                                          }
                                          @if (pedidoEnviadoCliente.observacao_nf != null && pedidoEnviadoCliente.observacao_nf != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="12"><b>Observação Nota Fiscal:</b> {{ pedidoEnviadoCliente.observacao_nf }}</td>
                                            </tr>
                                          }
                                        </tfoot>
                                      </table>
                                    </cdk-virtual-scroll-viewport>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                    @if (modelo_tela_ligacoes == 1) {
                      <!-- Modelo 2 -->
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-center tabela_borda">Status</th>
                              <th class="text-center tabela_borda">Nro Pedido</th>
                              <th class="tabela_borda">Cliente</th>
                              <th class="text-right tabela_borda">Total: R$</th>
                              <th class="text-right tabela_borda">Volume Total: R$</th>
                              <th class="text-center tabela_borda">Data do Pedido</th>
                              <th class="tabela_borda">Prazo Pagto</th>
                              <th class="text-center tabela_borda">Tipo</th>
                              <th class="text-center tabela_borda">Nota Fiscal</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (pedidoEnviadoCliente of pedidosEnviadosClientes; track pedidoEnviadoCliente; let i = $index) {
                              <tr>
                                <td class="text-center tabela_acao">
                                  <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensEnviados(i, pedidoEnviadoCliente.order_id_app)"></i>
                                </td>
                                <td class="text-center tabela_borda">
                                  @if (pedidoEnviadoCliente.status_pedido == 'À Integrar') {
                                    <span class="badge badge-primary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Aprov') {
                                    <span class="badge badge-warning">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Financeiro') {
                                    <span class="badge badge-financeiro">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Aguard Cad') {
                                    <span class="badge badge-secondary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Erro Integ') {
                                    <span class="badge badge-danger">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Faturado') {
                                    <span class="badge badge-info">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Faturado Div') {
                                    <span class="badge badge-other">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Integrado') {
                                    <span class="badge badge-success">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoEnviadoCliente.status_pedido == 'Reprovado') {
                                    <span class="badge badge-dark">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                  }
                                </td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.id_no_erp_do_cliente }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.name }}</td>
                                <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total | currency: 'BRL' }}</td>
                                <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total_volume | currency: 'BRL' }}</td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                <td class="tabela_borda">{{ pedidoEnviadoCliente.prazo_pgto }}</td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.cod_tipopedvenda }}</td>
                                <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.numero_nf }}</td>
                              </tr>
                              @if (i == pedidosItensEnviadosExpandido) {
                                <tr [@esvanecerDesvanecer]="'in'">
                                  <td class="p-3" colspan="10">
                                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                      <table class="table table-sm table-hover">
                                        <thead>
                                          <tr>
                                            <th class="text-center">Código</th>
                                            <th class="text-center tabela_borda">Sku</th>
                                            <th class="tabela_borda">Descrição</th>
                                            <th class="tabela_borda">Marca</th>
                                            <th class="text-center tabela_borda">Qtde</th>
                                            <th class="text-right tabela_borda">Unitário: R$</th>
                                            <th class="text-right tabela_borda">Total: R$</th>
                                            <th class="text-right tabela_borda">Volume: R$</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *cdkVirtualFor="let pedidoItemEnviado of pedidosItensEnviados; templateCacheSize: 0;">
                                            <tr>
                                              <td class="text-center">{{ pedidoItemEnviado.codigo }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemEnviado.referencia_cliente }}</td>
                                              <td class="tabela_borda">{{ pedidoItemEnviado.produto }}</td>
                                              <td class="tabela_borda">{{ pedidoItemEnviado.grupo_estoque }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemEnviado.quantity }}</td>
                                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemEnviado.vr_unitario_original) }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemEnviado.volume | currency: 'BRL' }}</td>
                                            </tr>
                                          </ng-container>
                                        </tbody>
                                        <tfoot>
                                          @if (pedidoEnviadoCliente.observacao_interna != null && pedidoEnviadoCliente.observacao_interna != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedidoEnviadoCliente.observacao_interna }}</td>
                                            </tr>
                                          }
                                          @if (pedidoEnviadoCliente.observacao_nf != null && pedidoEnviadoCliente.observacao_nf != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedidoEnviadoCliente.observacao_nf }}</td>
                                            </tr>
                                          }
                                        </tfoot>
                                      </table>
                                    </cdk-virtual-scroll-viewport>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                  </div>
                </ng-template>
              </li>
              <!-- Pedidos Não Enviados (Cliente) -->
              <li [ngbNavItem]="'tab-nao-enviados'">
                <a ngbNavLink>
                  <b>Não Enviados</b>
                </a>
                <ng-template ngbNavContent>
                  <div class="bg-white pt-3">
                    @if (modelo_tela_ligacoes == 0) {
                      <!-- Modelo 1 -->
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-center tabela_borda">Status</th>
                              <th class="text-center tabela_borda">Nro Pedido</th>
                              <th class="tabela_borda">Vend Externo</th>
                              <th class="tabela_borda">Vend Interno</th>
                              <th class="tabela_borda">Cliente</th>
                              <th class="text-right tabela_borda">Total: R$</th>
                              <th class="text-right tabela_borda">Litragem</th>
                              <th class="text-center tabela_borda">Criado</th>
                              <th class="tabela_borda">Prazo Pagto</th>
                              <th class="text-center tabela_borda">Tipo</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (pedidoNaoEnviadoCliente of pedidosNaoEnviadosClientes; track pedidoNaoEnviadoCliente; let i = $index) {
                              <tr>
                                <td class="text-center tabela_acao">
                                  <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensNaoEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensNaoEnviados(i, pedidoNaoEnviadoCliente.order_id_app)"></i>
                                </td>
                                <td class="text-center tabela_borda">
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Orçamento') {
                                    <span class="badge badge-warning">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Não Enviado') {
                                    <span class="badge badge-primary">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Reprovado') {
                                    <span class="badge badge-dark">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                </td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_id_app }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.vend_ext }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.vend_int }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.name }}</td>
                                <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total | currency: 'BRL' }}</td>
                                <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total_litragem | currency: 'BRL' : '' }}</td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.prazo_pgto }}</td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.cod_tipopedvenda }}</td>
                              </tr>
                              @if (i == pedidosItensNaoEnviadosExpandido) {
                                <tr [@esvanecerDesvanecer]="'in'">
                                  <td class="p-3" colspan="11">
                                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                      <table class="table table-sm table-hover">
                                        <thead>
                                          <tr>
                                            <th class="text-center">Código</th>
                                            <th class="tabela_borda">Descrição</th>
                                            <th class="text-center tabela_borda">Qtde</th>
                                            <th class="text-right tabela_borda">Unitário: R$</th>
                                            @if (exibirFatorFinanceiroNaoEnviados) {
                                              <th class="text-right tabela_borda">Fator: R$</th>
                                            }
                                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                              <th class="text-right tabela_borda">Imposto: R$</th>
                                            }
                                            @if (exibirFatorFinanceiroNaoEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                              <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                            }
                                            <th class="text-right tabela_borda">Sub-Total: R$</th>
                                            @if (is_master || is_manager || is_diretor) {
                                              <th class="text-right tabela_borda">Margem: %</th>
                                            }
                                            <th class="text-right tabela_borda">Tabela: R$</th>
                                            <th class="tabela_borda">Promoção</th>
                                            <th class="text-right tabela_borda">Preço Promoção: R$</th>
                                            <th class="text-right tabela_borda">Desconto: R$</th>
                                            <th class="text-right tabela_borda">Desconto: %</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *cdkVirtualFor="let pedidoItemNaoEnviado of pedidosItensNaoEnviados; templateCacheSize: 0;">
                                            <tr>
                                              <td class="text-center">{{ pedidoItemNaoEnviado.referencia_cliente }}</td>
                                              <td class="tabela_borda">{{ pedidoItemNaoEnviado.produto }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.quantity }}</td>
                                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemNaoEnviado.vr_unitario_original) }}</td>
                                              @if (exibirFatorFinanceiroNaoEnviados) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.fator_financeiro | currency: 'BRL' }}</td>
                                              }
                                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.valor_imposto | currency: 'BRL' }}</td>
                                              }
                                              @if (exibirFatorFinanceiroNaoEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_unitario_acumulado | currency: 'BRL' }}</td>
                                              }
                                              <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                              @if (is_master || is_manager || is_diretor) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.mkt | currency: 'BRL' : '' }}%</td>
                                              }
                                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ (pedidoItemNaoEnviado._api_preco_tabela || pedidoItemNaoEnviado.preco_tabela) | currency: 'BRL' }}</td>
                                              }
                                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ (pedidoItemNaoEnviado._api_precotabela2 || pedidoItemNaoEnviado.precotabela2) | currency: 'BRL' }}</td>
                                              }
                                              <td class="tabela_borda">{{ pedidoItemNaoEnviado.nome_promocao }}</td>
                                              <td class="text-right tabela_borda">{{ (pedidoItemNaoEnviado._api_preco_tabela || pedidoItemNaoEnviado.preco_tabela) | currency: 'BRL' }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.valor_desconto | currency: 'BRL' }}</td>
                                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.desc_aplicado | currency: 'BRL' : '' }}%</td>
                                              }
                                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                                              }
                                            </tr>
                                            @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItemNaoEnviado.observacao_item != null && pedidoItemNaoEnviado.observacao_item != '') {
                                              <tr>
                                                <td></td>
                                                <td class="tabela_borda" colspan="14">
                                                  {{ pedidoItemNaoEnviado.observacao_item }}
                                                </td>
                                              </tr>
                                            }
                                          </ng-container>
                                        </tbody>
                                        <tfoot>
                                          @if (pedidoNaoEnviadoCliente.observacao_interna != null && pedidoNaoEnviadoCliente.observacao_interna != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="15"><b>Observação Interna:</b> {{ pedidoNaoEnviadoCliente.observacao_interna }}</td>
                                            </tr>
                                          }
                                          @if (pedidoNaoEnviadoCliente.observacao_nf != null && pedidoNaoEnviadoCliente.observacao_nf != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="15"><b>Observação Nota Fiscal:</b> {{ pedidoNaoEnviadoCliente.observacao_nf }}</td>
                                            </tr>
                                          }
                                        </tfoot>
                                      </table>
                                    </cdk-virtual-scroll-viewport>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                    @if (modelo_tela_ligacoes == 1) {
                      <!-- Modelo 2 -->
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th></th>
                              <th class="text-center tabela_borda">Status</th>
                              <th class="text-center tabela_borda">Nro Pedido</th>
                              <th class="tabela_borda">Cliente</th>
                              <th class="text-right tabela_borda">Total: R$</th>
                              <th class="text-right tabela_borda">Volume Total: R$</th>
                              <th class="text-center tabela_borda">Data do Pedido</th>
                              <th class="tabela_borda">Prazo Pagto</th>
                              <th class="text-center tabela_borda">Tipo</th>
                              <th class="text-center tabela_borda">Nota Fiscal</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (pedidoNaoEnviadoCliente of pedidosNaoEnviadosClientes; track pedidoNaoEnviadoCliente; let i = $index) {
                              <tr>
                                <td class="text-center tabela_acao">
                                  <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensNaoEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensNaoEnviados(i, pedidoNaoEnviadoCliente.order_id_app)"></i>
                                </td>
                                <td class="text-center tabela_borda">
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Orçamento') {
                                    <span class="badge badge-warning">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Não Enviado') {
                                    <span class="badge badge-primary">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                  @if (pedidoNaoEnviadoCliente.status_pedido == 'Reprovado') {
                                    <span class="badge badge-dark">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                  }
                                </td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.id_no_erp_do_cliente }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.name }}</td>
                                <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total | currency: 'BRL' }}</td>
                                <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total_volume | currency: 'BRL' }}</td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.prazo_pgto }}</td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.cod_tipopedvenda }}</td>
                                <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.numero_nf }}</td>
                              </tr>
                              @if (i == pedidosItensNaoEnviadosExpandido) {
                                <tr [@esvanecerDesvanecer]="'in'">
                                  <td class="p-3" colspan="10">
                                    <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                      <table class="table table-sm table-hover">
                                        <thead>
                                          <tr>
                                            <th class="text-center">Código</th>
                                            <th class="text-center tabela_borda">Sku</th>
                                            <th class="tabela_borda">Descrição</th>
                                            <th class="tabela_borda">Marca</th>
                                            <th class="text-center tabela_borda">Qtde</th>
                                            <th class="text-right tabela_borda">Unitário: R$</th>
                                            <th class="text-right tabela_borda">Total: R$</th>
                                            <th class="text-right tabela_borda">Volume: R$</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *cdkVirtualFor="let pedidoItemNaoEnviado of pedidosItensNaoEnviados; templateCacheSize: 0;">
                                            <tr>
                                              <td class="text-center">{{ pedidoItemNaoEnviado.codigo }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.referencia_cliente }}</td>
                                              <td class="tabela_borda">{{ pedidoItemNaoEnviado.produto }}</td>
                                              <td class="tabela_borda">{{ pedidoItemNaoEnviado.grupo_estoque }}</td>
                                              <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.quantity }}</td>
                                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemNaoEnviado.vr_unitario_original) }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                              <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.volume | currency: 'BRL' }}</td>
                                            </tr>
                                          </ng-container>
                                        </tbody>
                                        <tfoot>
                                          @if (pedidoNaoEnviadoCliente.observacao_interna != null && pedidoNaoEnviadoCliente.observacao_interna != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedidoNaoEnviadoCliente.observacao_interna }}</td>
                                            </tr>
                                          }
                                          @if (pedidoNaoEnviadoCliente.observacao_nf != null && pedidoNaoEnviadoCliente.observacao_nf != '') {
                                            <tr>
                                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedidoNaoEnviadoCliente.observacao_nf }}</td>
                                            </tr>
                                          }
                                        </tfoot>
                                      </table>
                                    </cdk-virtual-scroll-viewport>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="t"></div>
          </div>
        }
        <!-- RESUMO FINANCEIRO removido daqui — agora está no modal #resumoFinanceiroModal -->
        @if (!freteValidado) {
          <div class="alert mt-3" [class.alert-info]="estadoFrete === 'calculando'"
            [class.alert-danger]="estadoFrete !== 'calculando'" role="status" aria-live="polite">
            @if (estadoFrete === 'calculando') {
              <span>Calculando frete… Aguarde para imprimir, salvar ou enviar o pedido.</span>
            } @else {
              <span>Não foi possível validar o frete. Recalcule para imprimir, salvar ou enviar o pedido.</span>
              <button class="btn btn-outline-danger ml-3" type="button" (click)="recalcularFrete()">Recalcular frete</button>
            }
          </div>
        }
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 rodape_conteudo_esquerda">
            <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(3)">Retornar</button>
            @if (whatsappAtendimentoSelecionadoExterno != 0) {
              <button class="btn btn-outline-secondary btn_formulario" type="button" (click)="cancelarPedidoWhatsAppOficial()">Cancelar Pedido</button>
            }
          </div>
          <div class="flex-grow-1 text-right">
            @if (!pedidoAprovarExterno) {
              <button class="btn btn-success btn_formulario" type="button" [disabled]="!freteValidado" (click)="imprimirPedidoOrcamento()">Imprimir</button>
            }
            @if (!pedidoAprovarExterno) {
              <button class="btn btn-success btn_formulario" type="button" [disabled]="!freteValidado" (click)="salvar()">Salvar</button>
            }
            <!-- Enviar pedido NORMAL -->
            @if (pedido == null || !pedido.pendencia) {
              @if (pedidoOrcamentoSelecionado == 1 && !pedidoAprovarExterno) {
                <button class="btn btn-success btn_formulario" type="button"
                [disabled]="!freteValidado" (click)="modalDescontoItens(descontoItens)">Salvar / Enviar</button>
              }
            }
            <!-- Enviar pedido PENDÊNCIA: bloqueado se falta estoque (só quando flag ativa) -->
            @if (usaPendencia && pedido != null && pedido.pendencia) {
              @if (pedidoOrcamentoSelecionado == 1 && !pedidoAprovarExterno && !envioPendenciaBloqueado) {
                <button class="btn btn-success btn_formulario" type="button"
                [disabled]="!freteValidado" (click)="modalDescontoItens(descontoItens)">Enviar Pendência</button>
              }
              @if (pedidoOrcamentoSelecionado == 1 && !pedidoAprovarExterno && envioPendenciaBloqueado) {
                <button class="btn btn-warning btn_formulario" type="button" disabled
                  title="Não há estoque suficiente para todos os itens pendentes.">
                  &#9888; Envio bloqueado (falta estoque)
                </button>
              }
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-danger btn_formulario" type="button" (click)="reprovar(pedidoReprovar)">Reprovar</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirResumoFinanceiro(resumoFinanceiroModal)">Analisar</button>
            }
            @if ((is_master || is_diretor) && clienteSelecionado != null) {
              <button class="btn btn-info btn_formulario" type="button" (click)="abrirAnaliseFinanceiraCliente(resumoFinanceiroModal)">Análise Financeira</button>
            }
            @if (pedidoAprovarExterno) {
              <button class="btn btn-success btn_formulario" type="button" (click)="aprovar()">Aprovar</button>
            }
          </div>
        </div>
        @if (!pedidoAprovarExterno) {
          <div class="d-flex justify-content-end">
            <div class="pt-2">
              <div class="text-secondary">
                <b>Atenção! Pedido após enviado não poderá mais ser alterado.</b>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
</div>
